import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feedback-goal-modal"
export default class extends Controller {
  static targets = ["goalModal", "goalModalItem", "goalTextField"]

  connect() {
    return this.goalTextFieldTarget
  }

  openModal(e) {
    e.preventDefault()
    this.goalModalTarget.classList.remove('hidden')
  }

  closeModal(e) {
    e.preventDefault()
    this.goalModalTarget.classList.add('hidden')
  }

  getGoalText(e) {
    const clickedItem = e.currentTarget;
    const content = clickedItem.textContent.trim();
    const previewCategory = document.querySelector(`[data-feedback-goal-modal-target="weeklyGoalPreview"]`);

    this.goalTextFieldTarget.value = content
    previewCategory.textContent = content
    this.closeModal(e)
  }
}
